/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLayoutGridRemove = createReactComponent("outline", "layout-grid-remove", "IconLayoutGridRemove", [["path", { "d": "M4 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-4z", "key": "svg-0" }], ["path", { "d": "M14 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-4z", "key": "svg-1" }], ["path", { "d": "M4 15a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-4z", "key": "svg-2" }], ["path", { "d": "M14 17h6", "key": "svg-3" }]]);

export { IconLayoutGridRemove as default };
//# sourceMappingURL=IconLayoutGridRemove.mjs.map
